// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Location: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 42" enableBackground="new 0 0 30 42" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M15,0.17c-8.06,0-14.58,6.52-14.58,14.58C0.42,25.69,15,41.83,15,41.83
	s14.58-16.15,14.58-27.08C29.58,6.69,23.06,0.17,15,0.17z M15,19.96c-2.88,0-5.21-2.33-5.21-5.21S12.12,9.54,15,9.54
	s5.21,2.33,5.21,5.21S17.88,19.96,15,19.96z"/>
</svg>;
};

export default React.memo(Location);
